import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'i18n/LocaleContext';
import MetaDecorator from 'components/layout/MetaDecorator';

export function ThankYouKeyPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='flex-1 max-w-[860px] w-full mx-auto py-10 px-6 flex flex-col items-center'>
      <MetaDecorator
        title={t('RVS.COMPONENT.ENTITLEMENT_KEY.HTML.ALERT_REGISTRATION_SUCCESSFUL', 'Registration Complete')}
        description='Your Roland Cloud key has been registered.'
        link='thank-you-key'
        addPostfixTitle
        noIndex
      />
      <h1 className='text-5xl font-bold text-center py-10'>
        {t('RVS.COMPONENT.ENTITLEMENT_KEY.HTML.ALERT_REGISTRATION_SUCCESSFUL', 'Registration Complete')}
      </h1>

      <div className='rounded-2xl border-black/50 border flex flex-col items-center p-12 text-center max-w-[520px] w-full'>
        <div className='text-6xl mb-6'>🎉</div>
        <p className='text-gray-600 text-lg mb-8'>
          {t('RVS.COMPONENT.ENTITLEMENT_KEY.VALIDATION.REGISTERED_COMPLETE', 'Your key has been successfully registered. Your Roland Cloud content is now available.')}
        </p>
        <button
          type='button'
          className='btn-primary px-10'
          onClick={() => navigate('/account-detail')}
        >
          {t('RVS.COMPONENT.TOOLBAR.BUTTON.HOME', 'Go to My Account')}
        </button>
      </div>
    </div>
  );
}
